import { BaseModel } from "../../../../../../../core/_base/crud";

export class TimKiemNangCaoModel extends BaseModel {
    Id_CT: number
    SoPhieu : string
    MaHH : string
    TenHH: string
    SoLuong: number
    GiaMin: number
    GiaMax: number
    GiaKhachHangMongMuon: number
    NgayYeuCauBG: Date
    KLSaiSo: number
    clear(){
        this.Id_CT = 0
        this.SoPhieu  = ''
        this.MaHH = ''
        this.TenHH = ''
        this.SoLuong = 0
        this.GiaMin = 0
        this.GiaMax = 0
        this.GiaKhachHangMongMuon = 0
        this.NgayYeuCauBG = new Date()
        this.KLSaiSo = null;
    }

    copy(item: TimKiemNangCaoModel){
        this.Id_CT = item.Id_CT
        this.SoPhieu = item.SoPhieu
        this.MaHH = item.MaHH
        this.TenHH = item.TenHH
        this.SoLuong = item.SoLuong
        this.GiaMin = item.GiaMin
        this.GiaMax = item.GiaMax
        this.GiaKhachHangMongMuon = item.GiaKhachHangMongMuon
        this.NgayYeuCauBG = item.NgayYeuCauBG
        this.KLSaiSo = item.KLSaiSo;
    }
}